import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { removeAllFiles, resetFilesState } from '../files/files.actions';
import { ObjectUrlService } from '../files/object-url/object-url-service.service';
import { resetNavigationState } from '../navigation/navigation.actions';
import { resetSettingsState } from '../settings/settings.actions';

@Injectable({ providedIn: 'root' })
export class UploaderDataFacade {
  private readonly store = inject(Store);
  private readonly objectUrlService = inject(ObjectUrlService);

  resetUploader(): void {
    this.store.dispatch(removeAllFiles());
    this.store.dispatch(resetFilesState());
    this.store.dispatch(resetNavigationState());
    this.store.dispatch(resetSettingsState());
    this.objectUrlService.revokeObjectUrls();
  }
}
